import React from 'react';

import { LightboxItem } from '$partials/base/index.js';
import { Media } from '$partials/media/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').Lightbox}
 */
const Lightbox = ({
    items = [],
    modulePaddingClasses = '',
    offsetColumns = false,
    parent
}) => {
    if (!items?.length) {
        return null;
    }

    const itemsMarkup = items.map((item) => {
        const width = offsetColumns ? ' w-full sm:w-4/8' : ' w-full sm:w-6/12';

        return (
            <div
                className={`layout-grid-col${item.width === 'half' ? width : ' w-full'}`}
                key={item.id}>
                <figure>
                    {parent === 'FoodDrink' || parent === 'GenericDetail' ? (
                        <div className='text-[0] leading-[0] tracking-normal pointer-events-none select-none'>
                            <Media
                                image={item.media?.image ? { ...item.media.image } : undefined}
                                video={item.media?.video ? {
                                    autoPlay: true,
                                    controls: false,
                                    loop: true,
                                    muted: true,
                                    ...item.media.video
                                } : undefined}
                                videoEmbed={item.media?.videoEmbed ? { ...item.media.videoEmbed } : undefined} />
                        </div>
                    ) : (
                        <LightboxItem
                            heading={item.heading}
                            id={item.id}
                            media={item.media}
                            text={item.text}>
                            <div className='media-wrapper text-[0] leading-[0] tracking-normal pointer-events-none select-none'>
                                <Media
                                    image={item.media?.image ? { ...item.media.image } : undefined}
                                    video={item.media?.video ? {
                                        autoPlay: true,
                                        controls: false,
                                        loop: true,
                                        muted: true,
                                        ...item.media.video
                                    } : undefined}
                                    videoEmbed={item.media?.videoEmbed ? { ...item.media.videoEmbed } : undefined} />
                            </div>
                        </LightboxItem>
                    )}


                    {(item.heading || item.text) && (
                        <figcaption className='pt-8'>
                            {item.heading && (
                                <p className='type-style-body-bold'>{item.heading}</p>
                            )}

                            {item.text && (
                                <p className='type-style-body'>{item.text}</p>
                            )}
                        </figcaption>
                    )}
                </figure>
            </div>
        );
    });

    return (
        <section className='module-lightbox'>
            <div className={`layout-container bg-neutral-00 ${modulePaddingClasses}`}>
                <div className='layout-grid gap-y-16'>
                    {offsetColumns ? (
                        <>
                            <div className='hidden sm:block sm:w-4/12 md:w-3/12' />

                            <div className='w-full sm:w-8/12 md:w-9/12'>
                                <div className='flex flex-wrap gap-y-16'>
                                    {itemsMarkup}
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            {itemsMarkup}
                        </>
                    )}
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Lightbox;
